import { Product } from '../types';

export const SolutionsKm: Product[] = [
   {
      id: 1,
      slug: 'sales',
      name: 'ដំណោះស្រាយការលក់',
      shortName: 'ការលក់',
      tagline: 'ចាប់អតិថិជន ធ្វើសម្រង់តម្លៃ គិតលុយ និងប្រមូលប្រាក់ ក្នុងដំណើរការតែមួយ',
      docsUrl: 'https://docs.akas.co/en/crm/',
      description:
         'លក់បានគ្រប់ទីកន្លែង ដោយភ្ជាប់ការលក់តាមបញ្ជរ ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជនចូលគ្នា។ អ្នកបង្កើតសម្រង់តម្លៃបានលឿន បម្លែងជាវិក្កយបត្របានភ្លាម ហើយតាមដានចំណូលពីអតិថិជនសក្តានុពលរហូតដល់ការទូទាត់ ជាមួយ AKAS។',
      images: [],
      backgroundImage: '/images/backgrounds/crm.jpeg',
      mainFeatures: [
         {
            icon: '🧾',
            title: 'សម្រង់តម្លៃ និងវិក្កយបត្រ',
            description:
               'បង្កើតសម្រង់តម្លៃលម្អិតតាមទំនិញ រួមទាំងពន្ធ ការបញ្ចុះតម្លៃ និងលក្ខខណ្ឌទូទាត់។ ចុចតែម្តងដើម្បីបម្លែងជាវិក្កយបត្រ ហើយទទួលប្រាក់បានលឿនជាងមុន។',
            images: [],
         },
         {
            icon: '🛒',
            title: 'ការលក់តាមបញ្ជរ',
            description:
               'គិតលុយបានលឿនជាងមុន ជាមួយការស្កេនបាកូដ ការបោះពុម្ព ឬផ្ញើបង្កាន់ដៃតាមអ៊ីមែល ការរក្សាកន្ត្រកទំនិញបណ្តោះអាសន្ន និងការផ្ទៀងផ្ទាត់លុយក្នុងថត។ បន្តលក់បានទោះអ៊ីនធឺណិតដាច់។',
            images: [],
         },
         {
            icon: '🏪',
            title: 'ហាងអនឡាញ និងកាតាឡុក',
            description:
               'ផ្សព្វផ្សាយកាតាឡុកផលិតផលជាមួយកម្រិតតម្លៃផ្សេងៗ គ្រប់គ្រងចំនួនទំនិញដែលមាន និងទាញការបញ្ជាទិញពីគេហទំព័រ ទីផ្សារអនឡាញ និងហាងផ្ទាល់ ឱ្យមកជុំគ្នា។',
            images: [],
         },
         {
            icon: '🔄',
            title: 'ដំណើរការលក់ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
            description:
               'ទទួលអតិថិជនសក្តានុពលពីទម្រង់នៅគេហទំព័រ តាមដានឱកាសលក់ កំណត់ពេលតាមដានឡើងវិញ ហើយបញ្ជូនការងារទៅផ្នែកវិក្កយបត្រ និងការដឹកជញ្ជូនដោយស្វ័យប្រវត្តិ។',
            images: [],
         },
         {
            icon: '📦',
            title: 'ស្តុក និងការប្រគល់ទំនិញ',
            description:
               'មើលស្តុកតាមទីតាំងបានភ្លាមៗ កក់ស្តុកសម្រាប់ការបញ្ជាទិញដែលបានអនុម័ត ហើយគ្រប់គ្រងការជ្រើសរើសទំនិញ ការវេចខ្ចប់ និងការដឹកជញ្ជូន នៅកន្លែងតែមួយ។',
            images: [],
         },
         {
            icon: '📈',
            title: 'របាយការណ៍លក់',
            description:
               'មើលចំណូល រឹមចំណេញ ពន្ធ និងលទ្ធផលតាមឆានែល តាមរយៈផ្ទាំងគ្រប់គ្រងដែលបង្ហាញសូចនាករសមិទ្ធផលសំខាន់ៗ ស្របនឹងរបាយការណ៍លក់របស់ AKAS។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយលក់ — សម្រង់តម្លៃ, ការលក់តាមបញ្ជរ, ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន',
         description:
            'ដំណើរការសម្រង់តម្លៃ វិក្កយបត្រ ការលក់តាមបញ្ជរ ហាងអនឡាញ និងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន ក្នុងវេទិកាលក់តែមួយរបស់ AKAS។ លក់នៅហាង និងតាមអនឡាញ ដោយប្រើទំនិញ ស្តុក និងរបាយការណ៍រួមគ្នា។',
         keywords:
            'ដំណោះស្រាយលក់, ការលក់តាមបញ្ជរ, ហាងអនឡាញ, ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន, សម្រង់តម្លៃ, វិក្កយបត្រ, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✓',
            title: 'ដំណើរការអនុម័ត',
            description:
               'ផ្ញើការបញ្ចុះតម្លៃ កំណត់សម្គាល់ឥណទាន និងកិច្ចសន្យាធំៗ ទៅអនុម័តមុនពេលចុះបញ្ជី។',
         },
         {
            icon: '🌐',
            title: 'ភាសា និងរូបិយប័ណ្ណច្រើន',
            description:
               'ប្រើបានទាំងភាសាខ្មែរ និងអង់គ្លេសតាំងពីដំបូង ព្រមទាំងបន្ថែមភាសាផ្សេង តម្លៃច្រើនរូបិយប័ណ្ណ និងច្បាប់ពន្ធ។',
         },
         {
            icon: '⚡',
            title: 'ការលក់តាមបញ្ជរ ដែលលក់បានទោះគ្មានអ៊ីនធឺណិត',
            description:
               'បន្តលក់ពេលអ៊ីនធឺណិតដាច់ ហើយទិន្នន័យនឹងធ្វើសមកាលកម្មវិញពេលភ្ជាប់បាន។',
         },
         {
            icon: '🔌',
            title: 'ការតភ្ជាប់',
            description:
               'ភ្ជាប់ច្រកទូទាត់ ម៉ាស៊ីនស្កេនបាកូដ ម៉ាស៊ីនបោះពុម្ព និងកម្មវិធីបន្ថែមរបស់ AKAS។',
         },
         {
            icon: '🔔',
            title: 'ការជូនដំណឹង',
            description:
               'ជូនដំណឹងដល់ក្រុមលក់ ហិរញ្ញវត្ថុ និងប្រតិបត្តិការ នៅពេលមានព្រឹត្តិការណ៍សំខាន់លើការបញ្ជាទិញ និងការទូទាត់។',
         },
         {
            icon: '📝',
            title: 'កំណត់ត្រាសវនកម្ម',
            description:
               'មើលថានរណាបានធ្វើអ្វីលើសម្រង់តម្លៃ វិក្កយបត្រ និងវេនលក់តាមបញ្ជរ។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'ពីសម្រង់តម្លៃដល់ប្រាក់ លឿនជាងមុន',
            description:
               'បម្លែងអតិថិជនសក្តានុពលជាវិក្កយបត្របានរហ័ស ដោយមានការណែនាំពេលអនុម័ត និងការបញ្ជូនការងារស្វ័យប្រវត្តិ។',
         },
         {
            number: '02',
            title: 'គ្រប់គ្រងគ្រប់ឆានែលលក់',
            description:
               'ភ្ជាប់ការលក់តាមបញ្ជរ ហាងអនឡាញ និងការបញ្ជាទិញពាណិជ្ជកម្មរវាងអាជីវកម្ម ឱ្យដំណើរការស្របគ្នា ដោយប្រើប្រភពទំនិញ និងស្តុកតែមួយ។',
         },
         {
            number: '03',
            title: 'កាត់បន្ថយកំហុស',
            description:
               'កំណត់តម្លៃ ពន្ធ និងការកក់ស្តុកឱ្យមានស្តង់ដារតែមួយ ដើម្បីកាត់បន្ថយការងារធ្វើឡើងវិញ និងការខាតបង់។',
         },
         {
            number: '04',
            title: 'បទពិសោធន៍អតិថិជនប្រសើរជាងមុន',
            description:
               'អ្នកទិញឃើញតម្លៃស្មើគ្នាគ្រប់ឆានែល គិតលុយបានលឿន និងដឹងស្ថានភាពការបញ្ជាទិញច្បាស់លាស់។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ពីអតិថិជនសក្តានុពលដល់ប្រាក់',
         path: 'អតិថិជនសក្តានុពល → អតិថិជន → សម្រង់តម្លៃ → បញ្ជាលក់ → វិក្កយបត្រ → បង្កាន់ដៃ / ការលក់តាមបញ្ជរ / ហាង',
         steps: [
            {
               title: 'ឈ្នះកិច្ចសន្យា',
               description: 'ទទួលអតិថិជនសក្តានុពល បម្លែងជាអតិថិជន គ្រប់គ្រងដំណើរការលក់ ហើយផ្ញើសម្រង់តម្លៃដែលបានអនុម័តរួច។',
            },
            {
               title: 'អនុម័ត និងចេញវិក្កយបត្រ',
               description: 'បម្លែងសម្រង់តម្លៃជាបញ្ជាលក់ បន្ទាប់មកចេញវិក្កយបត្រដោយប្រើទំនិញ ពន្ធ និងលក្ខខណ្ឌដូចគ្នា។',
            },
            {
               title: 'លក់នៅហាង ឬតាមអនឡាញ',
               description: 'ការលក់តាមបញ្ជរ សម្រាប់ហាង និងភោជនីយដ្ឋាន ព្រមទាំងហាងអនឡាញ ប្រើកាតាឡុក និងស្តុករួមគ្នា។',
            },
            {
               title: 'ប្រមូលប្រាក់ និងមើលរបាយការណ៍',
               description: 'បង្កាន់ដៃ ការទូទាត់តាម KHQR ប្រាក់កក់ និងគណនីត្រូវទទួល ស្ថិតក្នុងផ្នែកចំណូល ហើយអាចចុះបញ្ជីទៅគណនេយ្យបាន។',
            },
         ],
      },
      highlights: [
         'សម្រង់តម្លៃបម្លែងជាបញ្ជាលក់ និងវិក្កយបត្រ',
         'ការលក់តាមបញ្ជរ សម្រាប់ហាង និងភោជនីយដ្ឋាន លើកាតាឡុកតែមួយ',
         'ហាងអនឡាញ ដំណើរការលក់ និងរបាយការណ៍ចំណូល',
      ],
      related: [
         { label: 'ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន', to: '/products/crm' },
         { label: 'ការគ្រប់គ្រងចំណូល', to: '/products/revenues' },
         { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
         { label: 'ហាងអនឡាញ', to: '/products/online-store' },
      ],
   },
   {
      id: 2,
      slug: 'inventory',
      name: 'ដំណោះស្រាយស្តុក',
      shortName: 'ស្តុក',
      tagline: 'បញ្ជាទិញ ទទួល ផ្ទេរ និងរក្សាស្តុកឱ្យមានតុល្យភាព គ្រប់ទីតាំង',
      docsUrl: 'https://docs.akas.co/en/inventory/',
      description:
         'គ្រប់គ្រងស្តុកគ្រប់ឃ្លាំង ឱ្យចំនួនក្នុងប្រព័ន្ធត្រូវនឹងរបស់ពិត ហើយបំពេញស្តុកបានទាន់ពេល ជាមួយដំណោះស្រាយស្តុករបស់ AKAS។',
      images: [],
      backgroundImage: '/images/solutions/inventory-solution.jpg',
      mainFeatures: [
         {
            icon: '📦',
            title: 'ស្តុកពហុទីតាំង',
            description:
               'មើលចំនួនទំនិញក្នុងដៃ ចំនួនដែលបានកក់ និងចំនួនដែលអាចសន្យាលក់បាន តាមឃ្លាំង ហាង ឬធ្នើរ។',
            images: [],
         },
         {
            icon: '🔄',
            title: 'ចលនាស្តុក',
            description:
               'ទទួល ផ្ទេរ និងកែតម្រូវស្តុក ដោយមានដានអនុម័ត និងកំណត់សម្គាល់ពីភាពខុសគ្នា។',
            images: [],
         },
         {
            icon: '🧾',
            title: 'ការទិញ និងការបំពេញស្តុក',
            description:
               'បង្កើតបញ្ជាទិញដោយផ្អែកលើចំណុចបញ្ជាទិញឡើងវិញ និងរយៈពេលដឹកជញ្ជូន។ ផ្ទៀងផ្ទាត់ទំនិញដែលបានទទួល ជាមួយវិក្កយបត្រអ្នកផ្គត់ផ្គង់។',
            images: [],
         },
         {
            icon: '🚚',
            title: 'ការប្រគល់ទំនិញ',
            description:
               'ជ្រើសរើស វេចខ្ចប់ និងដឹកជញ្ជូនតាមបញ្ជាលក់ ហើយជូនដំណឹងស្ថានភាពទៅផ្នែកលក់ និងហិរញ្ញវត្ថុ។',
            images: [],
         },
         {
            icon: '🏷️',
            title: 'តាមដានតាមកញ្ចប់ និងលេខស៊េរី',
            description:
               'កត់ត្រាលេខកញ្ចប់ លេខស៊េរី និងថ្ងៃផុតកំណត់ ដើម្បីតាមដានប្រភពទំនិញ និងហៅទំនិញត្រឡប់វិញបាន។',
            images: [],
         },
         {
            icon: '📈',
            title: 'ការវិភាគស្តុក',
            description:
               'តាមដានការចរាចរស្តុក អាយុស្តុក តម្លៃស្តុក និងការខាតបង់ តាមផ្ទាំងគ្រប់គ្រងដែលស្របនឹងរបាយការណ៍ AKAS។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយស្តុក — ស្តុក ការទិញ និងឃ្លាំង',
         description:
            'គ្រប់គ្រងស្តុកគ្រប់ឃ្លាំង ឱ្យចំនួនក្នុងប្រព័ន្ធត្រូវនឹងរបស់ពិត ហើយបំពេញស្តុកបានទាន់ពេល ជាមួយដំណោះស្រាយស្តុករបស់ AKAS។',
         keywords:
            'ដំណោះស្រាយស្តុក, ការគ្រប់គ្រងស្តុក, ឃ្លាំង, ការបំពេញស្តុក, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✅',
            title: 'រាប់ស្តុកជាប្រចាំ និងត្រួតពិនិត្យ',
            description:
               'រាប់ស្តុកតាមកាលវិភាគ ហើយផ្ទៀងផ្ទាត់ភាពខុសគ្នាជាមួយការអនុម័តច្បាស់លាស់។',
         },
         {
            icon: '📡',
            title: 'បាកូដ និងម៉ាស៊ីនស្កេន',
            description:
               'ស្កេនបាកូដដើម្បីទទួល និងជ្រើសរើសទំនិញបានលឿនជាងមុន។',
         },
         {
            icon: '🔔',
            title: 'ការជូនដំណឹង',
            description:
               'ទទួលដំណឹងពេលស្តុកតិច ការបញ្ជាទិញរង់ចាំ និងការទទួលទំនិញយឺតពេល។',
         },
         {
            icon: '🔌',
            title: 'ការតភ្ជាប់',
            description:
               'ភ្ជាប់ការលក់តាមបញ្ជរ ហាងអនឡាញ ការទិញ និងម៉ូឌុលគណនេយ្យ។',
         },
         {
            icon: '📝',
            title: 'កំណត់ត្រាសវនកម្ម',
            description: 'ដឹងច្បាស់ថានរណាកែស្តុក កែពេលណា និងហេតុអ្វី។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'ស្តុកត្រូវនឹងរបស់ពិត',
            description:
               'កាត់បន្ថយទាំងស្តុកអស់ និងស្តុកលើស ដោយមើលឃើញចំនួនស្តុកគ្រប់ទីតាំងបានភ្លាមៗ។',
         },
         {
            number: '02',
            title: 'ការប្រគល់ទំនិញលឿនជាងមុន',
            description:
               'ជ្រើសរើស វេចខ្ចប់ និងដឹកជញ្ជូនបានលឿន ដោយធ្វើតាមជំហានណែនាំដែលភ្ជាប់នឹងបញ្ជាលក់។',
         },
         {
            number: '03',
            title: 'ចំណាយលើស្តុកតិចជាងមុន',
            description:
               'បំពេញស្តុកតាមតម្រូវការពិត និងរយៈពេលដឹកជញ្ជូន ដើម្បីកាត់ស្តុកលើស។',
         },
         {
            number: '04',
            title: 'អនុលោម និងតាមដានបាន',
            description:
               'ការគ្រប់គ្រងលេខកញ្ចប់ លេខស៊េរី និងដានអនុម័ត ធ្វើឱ្យការហៅទំនិញត្រឡប់ និងការត្រួតពិនិត្យកាន់តែងាយស្រួល។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ទិញ រក្សាទុក លក់',
         path: 'បញ្ជាទិញ → ទទួលទំនិញ → ផ្ទេរ / កែតម្រូវ / ដកស្តុក → ចេញវិក្កយបត្រ កាត់ស្តុក',
         steps: [
            {
               title: 'បញ្ជាទិញ និងទទួល',
               description: 'បង្កើតបញ្ជាទិញទៅអ្នកផ្គត់ផ្គង់ បន្ទាប់មកទទួលទំនិញចូលទីតាំងដែលកំណត់។',
            },
            {
               title: 'ផ្ទេរស្តុក',
               description: 'ផ្ទេររវាងឃ្លាំង កែតម្រូវក្រោយការរាប់ស្តុក ឬប្រគល់ទំនិញសម្រាប់ការដកស្តុកដោយខ្លួនឯង។',
            },
            {
               title: 'លក់',
               description: 'ពេលចេញវិក្កយបត្រទំនិញក្នុងផ្នែកចំណូល ប្រព័ន្ធកាត់ចំនួនស្តុកក្នុងដៃដោយស្វ័យប្រវត្តិ។',
            },
            {
               title: 'ពិនិត្យ',
               description: 'តារាងតុល្យភាព និងរបាយការណ៍ស្តុក បង្ហាញច្បាស់ថានៅសល់អ្វីលើធ្នើ។',
            },
         ],
      },
      highlights: [
         'បញ្ជាទិញ និងទំនិញដែលបានទទួល',
         'ការផ្ទេរ ការកែតម្រូវ និងការដកស្តុកដោយខ្លួនឯង',
         'តុល្យភាពស្តុកធ្វើបច្ចុប្បន្នភាពភ្លាម ពេលចេញវិក្កយបត្រទំនិញ',
      ],
      related: [
         { label: 'ម៉ូឌុលស្តុក', to: '/products/inventory' },
         { label: 'ចំណាយ', to: '/products/expenses' },
         { label: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់ស្តុក', href: 'https://docs.akas.co/en/inventory/' },
      ],
   },
   {
      id: 3,
      slug: 'hr',
      name: 'ដំណោះស្រាយធនធានមនុស្ស',
      shortName: 'ធនធានមនុស្ស',
      tagline: 'ជ្រើសរើស ចុះវត្តមាន គណនាប្រាក់ខែ និងអភិវឌ្ឍបុគ្គលិក នៅលើកំណត់ត្រាតែមួយ',
      docsUrl: 'https://docs.akas.co/en/hrms/',
      description:
         'គ្រប់គ្រងដំណើរការពីជ្រើសរើសដល់ចាកចេញនៅលើកំណត់ត្រាបុគ្គលិកតែមួយ៖ ការជ្រើសរើស កិច្ចសន្យា វត្តមាន ច្បាប់ឈប់សម្រាក ប្រាក់ខែជាមួយរបាយការណ៍តាមច្បាប់ ការវាយតម្លៃ ការបណ្តុះបណ្តាល និងសេវាកម្មដោយខ្លួនឯង — ជាមួយដំណើរការអនុម័តដែលស្របនឹងរចនាសម្ព័ន្ធក្រុមហ៊ុនរបស់អ្នក។',
      images: [],
      backgroundImage: '/images/solutions/hr-solution.jpg',
      mainFeatures: [
         {
            icon: '👥',
            title: 'ការជ្រើសរើស និងការទទួលបុគ្គលិកថ្មី',
            description:
               'សំណើការងារក្លាយជាការប្រកាសទំនេរ ពាក្យសុំហូរទៅការជ្រើសរើស ហើយបុគ្គលិកថ្មីចូលផ្នែកបុគ្គលិក ជាមួយកិច្ចសន្យា ប្រាក់ខែ កាលវិភាគ និងកូតាឈប់សម្រាក។',
            images: [],
         },
         {
            icon: '💻',
            title: 'សេវាកម្មដោយខ្លួនឯង',
            description:
               'បុគ្គលិកស្នើសុំឈប់សម្រាក ប្រាក់ថែមម៉ោង ការបណ្តុះបណ្តាល សំណើការងារ និងការលាឈប់ពីផ្ទាំងគ្រប់គ្រង។ អ្នកគ្រប់គ្រងអនុម័ត ហើយបុគ្គលិកមើលប័ណ្ណប្រាក់ខែ និងសំណើរង់ចាំ។',
            images: [],
         },
         {
            icon: '🕒',
            title: 'វត្តមាន និងឈប់សម្រាក',
            description:
               'ការចុះវត្តមានតាមជីវមាត្រ QR កាលវិភាគ និងតារាងម៉ោង ចូលទៅសមតុល្យឈប់សម្រាក និងប្រាក់ថែមម៉ោង — តាមថ្ងៃឈប់ និងច្បាប់អនុម័តដែលអ្នកកំណត់។',
            images: [],
         },
         {
            icon: '💰',
            title: 'ប្រាក់ខែជាមួយរបាយការណ៍តាមច្បាប់',
            description:
               'ធាតុប្រាក់ខែ ជួរគណនា និងបញ្ជីប្រាក់ខែ គណនាប័ណ្ណប្រាក់ខែ រួមទាំងពន្ធលើប្រាក់បៀវត្ស (TOS01) ទម្រង់ NSSF ប្រាក់ឋានន្តរសក្តិ ពន្ធអត្ថប្រយោជន៍បន្ថែម និងបញ្ជីផ្ទេរធនាគារ។',
            images: [],
         },
         {
            icon: '📈',
            title: 'ការវាយតម្លៃ និងការបណ្តុះបណ្តាល',
            description:
               'ធ្វើការវាយតម្លៃ និងសំណើបណ្តុះបណ្តាលនៅលើកំណត់ត្រាបុគ្គលិកតែមួយ ដើម្បីកុំឱ្យការអភិវឌ្ឍស្ថិតនៅក្នុងតារាងផ្សេង។',
            images: [],
         },
         {
            icon: '✅',
            title: 'ដំណើរការអនុម័ត',
            description:
               'បញ្ជូនសំណើឈប់សម្រាក ប្រាក់ថែមម៉ោង សំណើការងារ និងការចាកចេញ តាមរចនាសម្ព័ន្ធអង្គភាព — ជាមួយការផ្ទេរសិទ្ធិអនុម័តបណ្តោះអាសន្នពេលមានអ្នកអវត្តមាន។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយធនធានមនុស្ស — ពីជ្រើសរើសដល់ចាកចេញ ប្រាក់ខែ និងសេវាកម្មដោយខ្លួនឯង',
         description:
            'ដំណោះស្រាយធនធានមនុស្ស AKAS គ្របដណ្តប់ការជ្រើសរើស វត្តមាន ឈប់សម្រាក ប្រាក់ខែជាមួយរបាយការណ៍ពន្ធ និង NSSF ការវាយតម្លៃ និងសេវាកម្មដោយខ្លួនឯង នៅលើកំណត់ត្រាតែមួយ។',
         keywords:
            'ដំណោះស្រាយធនធានមនុស្ស, HRMS, ប្រាក់ខែ, វត្តមាន, ឈប់សម្រាក, NSSF, ពន្ធលើប្រាក់បៀវត្ស, AKAS',
      },
      additionalFeatures: [
         {
            icon: '🔐',
            title: 'ការការពារទិន្នន័យប្រាក់ខែ',
            description:
               'ម៉ឺនុយតាមតួនាទី និងការចូលប្រព័ន្ធបន្ថែម រក្សាទិន្នន័យប្រាក់ខែសម្រាប់អ្នកដែលមានសិទ្ធិ។',
         },
         {
            icon: '🌐',
            title: 'ខ្មែរ និងអង់គ្លេស',
            description:
               'អេក្រង់ ឯកសារ និងប័ណ្ណប្រាក់ខែ ក្នុងភាសាដែលក្រុមការងាររបស់អ្នកប្រើពិតប្រាកដ។',
         },
         {
            icon: '🔔',
            title: 'ការជូនដំណឹង',
            description:
               'ជូនដំណឹងអ្នកគ្រប់គ្រង និងបុគ្គលិកពីសំណើរង់ចាំ ប័ណ្ណប្រាក់ខែ និងព្រឹត្តិការណ៍ធនធានមនុស្សសំខាន់ៗ។',
         },
         {
            icon: '📝',
            title: 'ដានសវនកម្ម',
            description:
               'ដឹងច្បាស់ថានរណាកែកិច្ចសន្យា ធាតុប្រាក់ខែ និងការចាកចេញ — និងកែពេលណា។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'កំណត់ត្រាបុគ្គលិកតែមួយ',
            description:
               'ការជ្រើសរើស វត្តមាន ឈប់សម្រាក និងប្រាក់ខែ លែងត្រូវរស់នៅក្នុងឯកសារផ្សេងៗ។',
         },
         {
            number: '02',
            title: 'ថ្ងៃបើកប្រាក់ខែដោយមិនភ័យ',
            description:
               'របាយការណ៍តាមច្បាប់ចេញពីការគណនាប្រាក់ខែ រួចរាល់សម្រាប់ហិរញ្ញវត្ថុពិនិត្យ។',
         },
         {
            number: '03',
            title: 'សេវាកម្មដោយខ្លួនឯងដែលប្រើបាន',
            description:
               'បុគ្គលិកស្នើសុំដោយខ្លួនឯង អ្នកគ្រប់គ្រងអនុម័តតាមជួរច្បាស់លាស់។',
         },
         {
            number: '04',
            title: 'ច្បាប់ដែលអ្នកផ្លាស់ប្តូរបាន',
            description:
               'ផ្លូវអនុម័ត និងគោលការណ៍ប្រាក់ខែ តាមរចនាសម្ព័ន្ធរបស់អ្នក — មិនមែនគំរូថេររបស់អ្នកផ្តល់សេវា។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ពីជ្រើសរើសដល់ចាកចេញ',
         path: 'សំណើការងារ → ជ្រើសរើស → វត្តមាន និងឈប់សម្រាក → ប្រាក់ខែ → វាយតម្លៃ → ចាកចេញ',
         steps: [
            {
               title: 'ជ្រើសរើស',
               description:
                  'បង្កើត និងអនុម័តសំណើការងារ បើកការប្រកាសទំនេរ ទទួលពាក្យសុំ ហើយជ្រើសរើសចូលផ្នែកបុគ្គលិក។',
            },
            {
               title: 'ជួល',
               description:
                  'បង្កើតប្រវត្តិរូបបុគ្គលិក កិច្ចសន្យា ប្រាក់ខែ កូតាឈប់សម្រាក កាលវិភាគធ្វើការ និងខ្សែរបាយការណ៍។',
            },
            {
               title: 'វត្តមាន និងឈប់សម្រាក',
               description:
                  'ចុះវត្តមាន និង QR គណនាតារាងម៉ោង ហើយអនុម័តឈប់សម្រាកតាមសមតុល្យ និងថ្ងៃឈប់។',
            },
            {
               title: 'បើកប្រាក់ខែ និងអភិវឌ្ឍ',
               description:
                  'គណនាប្រាក់ថែមម៉ោង និងបញ្ជីប្រាក់ខែ ចេញប័ណ្ណប្រាក់ខែ និងរបាយការណ៍តាមច្បាប់ បន្ទាប់មកការវាយតម្លៃ និងការបណ្តុះបណ្តាល។',
            },
         ],
      },
      highlights: [
         'សេវាកម្មដោយខ្លួនឯងសម្រាប់ឈប់សម្រាក ប្រាក់ថែមម៉ោង ប័ណ្ណប្រាក់ខែ និងការលាឈប់',
         'ប្រាក់ខែជាមួយពន្ធ NSSF ប្រាក់ឋានន្តរសក្តិ និងបញ្ជីធនាគារ',
         'វត្តមានពីឧបករណ៍ QR កាលវិភាគ និងតារាងម៉ោង',
      ],
      related: [
         { label: 'ម៉ូឌុល HRMS', to: '/products/hrms' },
         { label: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់ HRMS', href: 'https://docs.akas.co/en/hrms/' },
         { label: 'គណនេយ្យ', to: '/products/accounting' },
      ],
   },
   {
      id: 4,
      slug: 'accounting',
      name: 'ដំណោះស្រាយគណនេយ្យ',
      shortName: 'គណនេយ្យ',
      tagline: 'ផ្គូផ្គងប្រតិបត្តិការទៅសៀវភៅធំ បន្ទាប់មកបិទគណនី',
      docsUrl: 'https://docs.akas.co/en/accounting/',
      description:
         'រៀបចំបញ្ជីគណនី ផ្គូផ្គងវិក្កយបត្រ និងវិក្កយបត្រអ្នកផ្គត់ផ្គង់ទៅគណនីសៀវភៅធំ ហើយឱ្យការលក់ និងចំណាយដែលបានអនុម័ត ចូលទិន្នានុក្រមដោយស្វ័យប្រវត្តិ — បន្ទាប់មករត់របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ តុល្យការសាកល្បង និងថវិកាប្រៀបធៀបការពិត។',
      images: [],
      backgroundImage: '/images/solutions/accounting-solution.jpg',
      mainFeatures: [
         {
            icon: '📒',
            title: 'បញ្ជីគណនី និងទិន្នានុក្រម',
            description:
               'បង្កើតរចនាសម្ព័ន្ធគណនី ទិន្នានុក្រម ឆ្នាំហិរញ្ញវត្ថុ និងថវិកា ដើម្បីឱ្យការចុះគណនី និងរបាយការណ៍ ប្រើសៀវភៅតែមួយ។',
            images: [],
         },
         {
            icon: '🔗',
            title: 'ការផ្គូផ្គងសៀវភៅធំ',
            description:
               'ប្រាប់ AKAS ថាវិក្កយបត្រ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ បង្កាន់ដៃ និងការទូទាត់ គួរចូលគណនីណា — ដើម្បីឱ្យប្រតិបត្តិការចុះគណនី ជំនួសការវាយបញ្ចូលឡើងវិញ។',
            images: [],
         },
         {
            icon: '✍️',
            title: 'ធាតុទិន្នានុក្រម',
            description:
               'ពិនិត្យធាតុដែលចូលដោយស្វ័យប្រវត្តិពីចំណូល និងចំណាយ បន្ទាប់មកបន្ថែមការកែតម្រូវដោយដៃពេលត្រូវការ។',
            images: [],
         },
         {
            icon: '📈',
            title: 'របាយការណ៍ហិរញ្ញវត្ថុ',
            description:
               'របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ និងតុល្យការសាកល្បង ពីសៀវភៅតែមួយដែលម៉ូឌុលប្រតិបត្តិការចុះទៅ។',
            images: [],
         },
         {
            icon: '🎯',
            title: 'ថវិកាប្រៀបធៀបការពិត',
            description:
               'ប្រៀបធៀបថវិកាជាមួយសកម្មភាពដែលបានចុះ ដើម្បីឱ្យផ្នែកនីមួយៗមើលឃើញភាពខុសគ្នា ដោយមិនត្រូវការតារាងផ្សេង។',
            images: [],
         },
         {
            icon: '🔒',
            title: 'ការគ្រប់គ្រងឆ្នាំហិរញ្ញវត្ថុ',
            description:
               'ឆ្នាំហិរញ្ញវត្ថុ និងអង្គភាពក្នុងការគ្រប់គ្រងប្រព័ន្ធ កំណត់ពេលណាអាចចុះគណនីបាន — ម៉ូឌុលទាំងអស់ប្រើប្រតិទិនតែមួយ។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយគណនេយ្យ — សៀវភៅធំ របាយការណ៍ និងថវិកា',
         description:
            'ដំណោះស្រាយគណនេយ្យ AKAS ផ្គូផ្គងឯកសារប្រតិបត្តិការទៅសៀវភៅធំ ហើយផ្តល់របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ និងថវិកាប្រៀបធៀបការពិត។',
         keywords:
            'ដំណោះស្រាយគណនេយ្យ, សៀវភៅធំ, របាយការណ៍ចំណូល, តារាងតុល្យការណ៍, ការផ្គូផ្គង GL, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✅',
            title: 'ម៉ឺនុយតាមតួនាទី',
            description:
               'គណនេយ្យករ និងអ្នកពិនិត្យ មើលឃើញតែទិន្នានុក្រម និងរបាយការណ៍ដែលតួនាទីរបស់ពួកគេអនុញ្ញាត។',
         },
         {
            icon: '🔔',
            title: 'ប្រវត្តិសម្រាប់សវនកម្ម',
            description:
               'លេខឯកសារដោយស្វ័យប្រវត្តិ និងប្រវត្តិផ្លាស់ប្តូរលើកំណត់ត្រារសើប ជួយការពិនិត្យ។',
         },
         {
            icon: '🔌',
            title: 'ភ្ជាប់នឹងប្រតិបត្តិការ',
            description:
               'ចំណូល ចំណាយ និងទ្រព្យសកម្មថេរ ចុះគណនីតាមការផ្គូផ្គងដែលអ្នកកំណត់។',
         },
         {
            icon: '🌐',
            title: 'ពហុភាសា',
            description:
               'ធ្វើការលើសៀវភៅជាភាសាខ្មែរ ឬអង់គ្លេស ជាមួយរចនាសម្ព័ន្ធគណនីតែមួយ។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'សៀវភៅតាមដានអាជីវកម្ម',
            description:
               'វិក្កយបត្រដែលលក់បាន ឬវិក្កយបត្រដែលបង់ហើយ ចុះសៀវភៅ — ហិរញ្ញវត្ថុពិនិត្យ ជំនួសការវាយឡើងវិញ។',
         },
         {
            number: '02',
            title: 'របាយការណ៍ដែលអាចទុកចិត្ត',
            description:
               'ចំណេញ-ខាត តារាងតុល្យការណ៍ និងលំហូរសាច់ប្រាក់ មកពីបញ្ជីគណនីតែមួយ។',
         },
         {
            number: '03',
            title: 'ថវិកាដែលមានន័យ',
            description:
               'ថវិកាប្រៀបធៀបការពិត បង្ហាញភាពខុសគ្នាទល់នឹងសកម្មភាពដែលបានចុះ។',
         },
         {
            number: '04',
            title: 'បិទគណនីដោយមានការគ្រប់គ្រង',
            description:
               'ឆ្នាំហិរញ្ញវត្ថុ និងការផ្គូផ្គង រក្សារយៈពេលឱ្យស្អាត និងការចុះគណនីឱ្យមានគោលបំណង។',
         },
      ],
      videos: [],
      workflow: {
         title: 'បិទគណនីពីប្រតិបត្តិការ',
         path: 'បញ្ជីគណនី → ការផ្គូផ្គង GL → ការចុះពីប្រតិបត្តិការ → របាយការណ៍',
         steps: [
            {
               title: 'រៀបចំសៀវភៅ',
               description: 'បង្កើតបញ្ជីគណនី និងកំណត់ទិន្នានុក្រម ឆ្នាំហិរញ្ញវត្ថុ និងថវិកា។',
            },
            {
               title: 'ផ្គូផ្គងប្រតិបត្តិការ',
               description:
                  'ប្រាប់ AKAS ថាវិក្កយបត្រ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ បង្កាន់ដៃ និងការទូទាត់ គួរចូលគណនីណា។',
            },
            {
               title: 'ប្រតិបត្តិការ',
               description:
                  'ចំណូល និងចំណាយ ចុះទិន្នានុក្រមពេលឯកសារត្រូវបានអនុម័ត។',
            },
            {
               title: 'ពិនិត្យ និងរាយការណ៍',
               description:
                  'ពិនិត្យធាតុទិន្នានុក្រម បន្ថែមការកែតម្រូវដោយដៃ បន្ទាប់មករត់របាយការណ៍ហិរញ្ញវត្ថុ និងថវិកាប្រៀបធៀបការពិត។',
            },
         ],
      },
      highlights: [
         'បញ្ជីគណនី ទិន្នានុក្រម និងថវិកា',
         'ការផ្គូផ្គង GL ពីវិក្កយបត្រ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ និងការទូទាត់',
         'របាយការណ៍ចំណូល តារាងតុល្យការណ៍ លំហូរសាច់ប្រាក់ តុល្យការសាកល្បង',
      ],
      related: [
         { label: 'ម៉ូឌុលគណនេយ្យ', to: '/products/accounting' },
         { label: 'ចំណូល', to: '/products/revenues' },
         { label: 'ចំណាយ', to: '/products/expenses' },
         { label: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់គណនេយ្យ', href: 'https://docs.akas.co/en/accounting/' },
      ],
   },
   {
      id: 5,
      slug: 'crm',
      name: 'ដំណោះស្រាយគ្រប់គ្រងអតិថិជន',
      shortName: 'គ្រប់គ្រងអតិថិជន',
      tagline: 'ពីអតិថិជនសក្តានុពលដល់សម្រង់តម្លៃ នៅលើគណនីអតិថិជនតែមួយ',
      docsUrl: 'https://docs.akas.co/en/crm/',
      description:
         'ចាប់អតិថិជនសក្តានុពល បម្លែងជាអតិថិជន គ្រប់គ្រងឱកាសលក់តាមបំពង់លក់ ហើយផ្ញើសម្រង់តម្លៃដែលបានអនុម័ត ដើម្បីបម្លែងជាបញ្ជាលក់ — ជាមួយគណនីអតិថិជនតែមួយដែលប្រើបន្តសម្រាប់វិក្កយបត្រ និងបង្កាន់ដៃ។',
      images: [],
      backgroundImage: '/images/solutions/crm-solution.jpg',
      mainFeatures: [
         {
            icon: '👤',
            title: 'អតិថិជនសក្តានុពល និងអតិថិជន',
            description:
               'កត់ត្រាអតិថិជនសក្តានុពល បម្លែងជាគណនីអតិថិជនរួមជាមួយចំណូល ហើយរក្សាកំណត់សម្គាល់ និងឯកសារ ឱ្យអ្នកហៅបន្ទាប់រកឃើញ។',
            images: [],
         },
         {
            icon: '📊',
            title: 'បំពង់លក់ និងឱកាស',
            description:
               'តាមដានតម្លៃដំណើរការ ដំណាក់កាល និងប្រូបាបិលីតេ នៅលើបំពង់លក់ដែលក្រុមអាចគ្រប់គ្រងបាន — មិនមែនតារាងផ្ទាល់ខ្លួន។',
            images: [],
         },
         {
            icon: '🧾',
            title: 'សម្រង់តម្លៃ',
            description:
               'បង្កើតសម្រង់តម្លៃលម្អិតតាមទំនិញ រួមទាំងពន្ធ ការបញ្ចុះតម្លៃ និងលក្ខខណ្ឌ។ ក្រោយអនុម័ត បម្លែងជាបញ្ជាលក់ដោយមិនវាយបន្ទាត់ឡើងវិញ។',
            images: [],
         },
         {
            icon: '🔄',
            title: 'បញ្ជូនទៅវិក្កយបត្រ',
            description:
               'សម្រង់តម្លៃដែលបានអនុម័ត បន្តក្នុងចំណូលជាបញ្ជាលក់ វិក្កយបត្រ និងបង្កាន់ដៃ នៅលើអតិថិជនតែមួយ។',
            images: [],
         },
         {
            icon: '📁',
            title: 'ប្រវត្តិការលក់',
            description:
               'មើលបញ្ជាទិញ និងវិក្កយបត្ររបស់អតិថិជននៅកន្លែងតែមួយ ដើម្បីតាមដានដោយប្រើប្រវត្តិពិត។',
            images: [],
         },
         {
            icon: '📈',
            title: 'របាយការណ៍ CRM',
            description:
               'របាយការណ៍សកម្មភាព និងការបម្លែង បង្ហាញថាអ្វីកំពុងរីកចម្រើន និងអ្វីជាប់គាំង។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយគ្រប់គ្រងអតិថិជន — អតិថិជនសក្តានុពល បំពង់លក់ និងសម្រង់តម្លៃ',
         description:
            'ដំណោះស្រាយ CRM របស់ AKAS គ្រប់គ្រងអតិថិជនសក្តានុពល អតិថិជន ឱកាសលក់ និងសម្រង់តម្លៃដែលបម្លែងជាបញ្ជាលក់ — នៅលើគណនីអតិថិជនតែមួយរួមជាមួយវិក្កយបត្រ។',
         keywords:
            'ដំណោះស្រាយ CRM, បំពង់លក់, សម្រង់តម្លៃ, អតិថិជនសក្តានុពល, គ្រប់គ្រងអតិថិជន, AKAS',
      },
      additionalFeatures: [
         {
            icon: '✅',
            title: 'ដំណើរការអនុម័ត',
            description:
               'បញ្ជូនការបញ្ចុះតម្លៃធំ និងសម្រង់តម្លៃឱ្យអនុម័ត មុនបម្លែងជាបញ្ជាទិញ។',
         },
         {
            icon: '🌐',
            title: 'ពហុភាសា',
            description:
               'ធ្វើការលើបំពង់លក់ជាភាសាខ្មែរ ឬអង់គ្លេស ជាមួយទិន្នន័យអតិថិជនរួម។',
         },
         {
            icon: '🔔',
            title: 'ការរំលឹកតាមដាន',
            description:
               'ការពារឱកាសលក់ពីការត្រជាក់ ដោយការរំលឹកនៅដំណាក់កាលសំខាន់ៗ។',
         },
         {
            icon: '🔌',
            title: 'ម៉ូឌុលភ្ជាប់គ្នា',
            description:
               'លក្ខខណ្ឌឥណទានពីការគ្រប់គ្រងប្រព័ន្ធអនុវត្ត ហើយចំណូល ការលក់តាមបញ្ជរ និងហាង ប្រើអតិថិជនតែមួយ។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'គ្មានការវាយបញ្ចូលពីរដង',
            description:
               'អតិថិជនដែលឈ្នះក្នុង CRM គឺជាគណនីតែមួយដែលហិរញ្ញវត្ថុចេញវិក្កយបត្រ។',
         },
         {
            number: '02',
            title: 'បំពង់លក់ដែលដំណើរការបាន',
            description:
               'ដំណាក់កាល តម្លៃ និងប្រូបាបិលីតេ រស់នៅកន្លែងដែលក្រុមធ្វើការរួចហើយ។',
         },
         {
            number: '03',
            title: 'ពីសម្រង់តម្លៃទៅបញ្ជាទិញលឿនជាងមុន',
            description:
               'សម្រង់តម្លៃដែលបានអនុម័ត បម្លែងដោយមិនវាយបន្ទាត់ទំនិញឡើងវិញ។',
         },
         {
            number: '04',
            title: 'បរិបទសម្រាប់រាល់ការហៅ',
            description:
               'កំណត់សម្គាល់ ឯកសារ និងប្រវត្តិការលក់ ធ្វើដំណើរជាមួយកំណត់ត្រាអតិថិជន។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ពីអតិថិជនសក្តានុពលដល់សម្រង់តម្លៃ',
         path: 'អតិថិជនសក្តានុពល → អតិថិជន → ឱកាសលក់ → សម្រង់តម្លៃ → ចំណូល',
         steps: [
            {
               title: 'ចាប់អតិថិជនសក្តានុពល',
               description: 'កត់ត្រាព័ត៌មានទំនាក់ទំនង និងប្រភព ដើម្បីកុំឱ្យការតាមដានបាត់ក្នុងប្រអប់សំបុត្រ។',
            },
            {
               title: 'បម្លែងជាអតិថិជន',
               description:
                  'បង្កើតគណនីអតិថិជនដែលប្រើក្នុង CRM និងចំណូល ជាមួយឱកាសលក់បើចាំបាច់។',
            },
            {
               title: 'ធ្វើការលើឱកាស',
               description:
                  'តាមដានតម្លៃ ដំណាក់កាល និងប្រូបាបិលីតេ នៅលើបំពង់លក់ដែលក្រុមអាចគ្រប់គ្រងបាន។',
            },
            {
               title: 'សម្រង់តម្លៃ បន្ទាប់មកវិក្កយបត្រ',
               description:
                  'ផ្ញើសម្រង់តម្លៃផ្លូវការ។ ក្រោយអនុម័ត បម្លែងជាបញ្ជាលក់ក្នុងចំណូល។',
            },
         ],
      },
      highlights: [
         'អតិថិជនសក្តានុពលបម្លែងជាអតិថិជន និងឱកាសលក់',
         'ដំណាក់កាលបំពង់លក់ជាមួយតម្លៃដំណើរការ និងប្រូបាបិលីតេ',
         'សម្រង់តម្លៃអនុម័ត បម្លែងជាបញ្ជាលក់',
      ],
      related: [
         { label: 'ម៉ូឌុល CRM', to: '/products/crm' },
         { label: 'ចំណូល', to: '/products/revenues' },
         { label: 'ដំណើរការលក់', to: '/solutions/sales' },
         { label: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់ CRM', href: 'https://docs.akas.co/en/crm/' },
      ],
   },
   {
      id: 6,
      slug: 'operations',
      name: 'ដំណោះស្រាយប្រតិបត្តិការ',
      shortName: 'ប្រតិបត្តិការ',
      tagline: 'បញ្ជរ ហាងអនឡាញ សាខា និងការអនុម័ត នៅលើផែនទីអង្គភាពតែមួយ',
      docsUrl: 'https://docs.akas.co/',
      description:
         'គ្រប់គ្រងការងារផ្នែកមុខ និងសាខាប្រចាំថ្ងៃនៅកន្លែងតែមួយ៖ ការលក់តាមបញ្ជរ (Mart និងភោជនីយដ្ឋាន) ហាងអនឡាញ ការណាត់ជួបគ្លីនិកពេលត្រូវការ និងច្បាប់ក្នុងការគ្រប់គ្រងប្រព័ន្ធសម្រាប់ទីតាំង តួនាទី និងការអនុម័ត — ដើម្បីឱ្យគ្រប់បណ្តាញលក់ទំនិញតែមួយ ចូលស្តុក និងសៀវភៅតែមួយ។',
      images: [],
      backgroundImage: '/images/solutions/operations-solution.jpg',
      mainFeatures: [
         {
            icon: '🛒',
            title: 'ការលក់តាមបញ្ជរ',
            description:
               'ការគិតលុយ Mart និងសេវាតុភោជនីយដ្ឋានជាមួយការបោះពុម្ពផ្ទះបាយ — លើ Windows macOS និង Android — ប្រើបញ្ជីទំនិញ និងស្តុកដូចគ្នាជាមួយចំណូល និងស្តុក។',
            images: [],
         },
         {
            icon: '🏪',
            title: 'ហាងអនឡាញ',
            description:
               'ផ្សព្វផ្សាយទំនិញ និងតម្លៃតែមួយលើអ៊ីនធឺណិត។ ការបញ្ជាទិញធ្វើសមកាល ដើម្បីឱ្យឃ្លាំង និងហិរញ្ញវត្ថុមិនត្រូវតាមដានពីបណ្តាញផ្សេង។',
            images: [],
         },
         {
            icon: '🏥',
            title: 'ប្រតិបត្តិការគ្លីនិក',
            description:
               'ការណាត់ជួប អ្នកជំងឺ និងស្តុកថ្នាំ សម្រាប់គ្លីនិកដែលត្រូវការផ្នែកទទួលភ្ញៀវ និងស្តុកក្នុងប្រព័ន្ធតែមួយ។',
            images: [],
         },
         {
            icon: '🗺️',
            title: 'សាខា និងទីតាំង',
            description:
               'កំណត់សាខា ឃ្លាំង រូបិយប័ណ្ណ និងប្រតិទិនហិរញ្ញវត្ថុម្តងក្នុងការគ្រប់គ្រងប្រព័ន្ធ — ម៉ូឌុលទាំងអស់គោរពផែនទីអង្គភាពតែមួយ។',
            images: [],
         },
         {
            icon: '✅',
            title: 'ច្បាប់អនុម័ត',
            description:
               'គូរផ្លូវអនុម័តសម្រាប់ឈប់សម្រាក សម្រង់តម្លៃ វិក្កយបត្រអ្នកផ្គត់ផ្គង់ និងស្តុក។ ផ្លាស់ប្តូរបានពេលអាជីវកម្មផ្លាស់ប្តូរ — មិនត្រូវស្ថាបនាឡើងវិញ។',
            images: [],
         },
         {
            icon: '🔐',
            title: 'តួនាទី និងសិទ្ធិ',
            description:
               'តួនាទីនីមួយៗមានម៉ឺនុយផ្ទាល់ខ្លួន។ ជំហានរសើបដូចប្រាក់ខែ នៅក្រោយការចូលប្រព័ន្ធបន្ថែម។',
            images: [],
         },
      ],
      meta: {
         title: 'AKAS | ដំណោះស្រាយប្រតិបត្តិការ — បញ្ជរ ហាង សាខា និងការអនុម័ត',
         description:
            'ដំណោះស្រាយប្រតិបត្តិការ AKAS ភ្ជាប់ការលក់តាមបញ្ជរ ហាងអនឡាញ គ្លីនិក ការរៀបចំពហុទីតាំង និងច្បាប់អនុម័ត ដើម្បីឱ្យគ្រប់បណ្តាញប្រើបញ្ជីទំនិញ និងផែនទីអង្គភាពតែមួយ។',
         keywords:
            'ដំណោះស្រាយប្រតិបត្តិការ, ការលក់តាមបញ្ជរ, ហាងអនឡាញ, ពហុទីតាំង, ការអនុម័ត, គ្លីនិក, AKAS',
      },
      additionalFeatures: [
         {
            icon: '🌐',
            title: 'ខ្មែរ និងអង់គ្លេស',
            description:
               'អេក្រង់ និងឯកសារក្នុងភាសាដែលអ្នកគិតលុយ និងអ្នកគ្រប់គ្រងប្រើពិតប្រាកដ។',
         },
         {
            icon: '⚡',
            title: 'បញ្ជរដែលដំណើរការពេលអ៊ីនធឺណិតដាច់',
            description:
               'បន្តលក់ពេលបណ្តាញដាច់ ហើយធ្វើសមកាលពេលភ្ជាប់វិញ។',
         },
         {
            icon: '🔌',
            title: 'បញ្ជីទំនិញរួម',
            description:
               'ទំនិញ តម្លៃ និងស្តុក មិនត្រូវវាយបញ្ចូលឡើងវិញសម្រាប់បណ្តាញនីមួយៗ។',
         },
         {
            icon: '📝',
            title: 'ដានសវនកម្ម',
            description:
               'លេខឯកសារ និងប្រវត្តិផ្លាស់ប្តូរ ជួយការពិនិត្យសាខា និងបញ្ជរ។',
         },
      ],
      benefits: [
         {
            number: '01',
            title: 'បញ្ជីទំនិញតែមួយគ្រប់ទី',
            description:
               'ការលក់នៅបញ្ជរ និងការបញ្ជាទិញលើបណ្តាញ កាត់ទំនិញស្តុកតែមួយ។',
         },
         {
            number: '02',
            title: 'បើកសាខាដោយមិនត្រូវគម្រោងថ្មី',
            description:
               'ទីតាំង និងតួនាទីកំណត់ម្តង ម៉ូឌុលទាំងអស់ទទួលយក។',
         },
         {
            number: '03',
            title: 'ច្បាប់តាមរបៀបធ្វើការរបស់អ្នក',
            description:
               'ការអនុម័តតាមរចនាសម្ព័ន្ធរបស់អ្នក — មិនមែនគំរូថេររបស់អ្នកផ្តល់សេវា។',
         },
         {
            number: '04',
            title: 'ពីផ្នែកមុខដល់សៀវភៅ',
            description:
               'សកម្មភាពបញ្ជរ និងហាង ហូរទៅចំណូល និងស្តុក — មិនមែនតារាងបិទថ្ងៃ។',
         },
      ],
      videos: [],
      workflow: {
         title: 'ពីបណ្តាញលក់ដល់បិទថ្ងៃ',
         path: 'កំណត់អង្គភាព និងបញ្ជីទំនិញ → លក់ (បញ្ជរ / ហាង / គ្លីនិក) → ស្តុក និងចំណូលធ្វើបច្ចុប្បន្នភាព → ពិនិត្យ',
         steps: [
            {
               title: 'កំណត់ផែនទី',
               description:
                  'កំណត់សាខា ឃ្លាំង តួនាទី រូបិយប័ណ្ណ និងផ្លូវអនុម័តក្នុងការគ្រប់គ្រងប្រព័ន្ធ។',
            },
            {
               title: 'ផ្សព្វផ្សាយម្តង',
               description:
                  'ទំនិញ និងតម្លៃរស់នៅក្នុងបញ្ជីតែមួយដែលបញ្ជរ ហាងអនឡាញ និងវិក្កយបត្រប្រើ។',
            },
            {
               title: 'លក់រាល់ថ្ងៃ',
               description:
                  'អ្នកគិតលុយ អតិថិជនលើបណ្តាញ និងផ្នែកទទួលភ្ញៀវគ្លីនិក ធ្វើការពីប្រព័ន្ធតែមួយ។',
            },
            {
               title: 'ផ្ទៀងផ្ទាត់ដោយមិនវាយឡើងវិញ',
               description:
                  'ចលនាស្តុក និងកំណត់ត្រាចំណូលធ្វើបច្ចុប្បន្នភាព ដើម្បីឱ្យឃ្លាំង និងហិរញ្ញវត្ថុមើលឃើញថ្ងៃតែមួយ។',
            },
         ],
      },
      highlights: [
         'របៀប Mart និងភោជនីយដ្ឋានលើបញ្ជីទំនិញរួម',
         'ការបញ្ជាទិញហាងអនឡាញធ្វើសមកាលទៅស្តុក និងចំណូល',
         'សាខា តួនាទី និងការអនុម័តកំណត់ម្តងសម្រាប់គ្រប់ម៉ូឌុល',
      ],
      related: [
         { label: 'ការលក់តាមបញ្ជរ', to: '/products/pos' },
         { label: 'ហាងអនឡាញ', to: '/products/online-store' },
         { label: 'គ្លីនិក', to: '/products/clinic' },
         { label: 'ដំណើរការលក់', to: '/solutions/sales' },
      ],
   },
];
